<template>
	<div class="min-h-screen flex flex-col items-center justify-center px-6 text-center">
		<p class="text-8xl font-bold text-gray-200 mb-4">{{ error.statusCode }}</p>
		<h1 class="text-2xl font-semibold text-gray-900 mb-2">
			{{ error.statusCode === 404 ? 'Page not found' : 'Something went wrong' }}
		</h1>
		<p class="text-gray-500 mb-8 max-w-sm">
			{{
				error.statusCode === 404
					? "The page you're looking for doesn't exist."
					: 'An unexpected error occurred. Please try again.'
			}}
		</p>
		<button
			class="px-6 py-2 bg-gray-900 text-white text-sm font-medium hover:bg-gray-700 transition-colors"
			@click="handleError"
		>
			Go home
		</button>
	</div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';

const props = defineProps<{ error: NuxtError }>();

const handleError = () => clearError({ redirect: '/' });
</script>
